import { AnimatePresence, motion } from "motion/react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

import { SupportForm } from "@/components/support/SupportForm";

interface SupportModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SupportModal({ isOpen, onClose }: SupportModalProps) {
  const portalTarget = document.querySelector(".dark") ?? document.body;

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {/* Backdrop */}
          <motion.div
            className="absolute inset-0 bg-black/50"
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          {/* Panel */}
          <motion.div
            className="relative z-10 h-full w-full overflow-y-auto border-black bg-white p-6 lg:mx-4 lg:h-auto lg:max-w-2xl lg:rounded-3xl lg:border lg:p-8 dark:border-white/20 dark:bg-[#2A2A2A]"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <div className="mb-6 flex items-center justify-between">
              <h2 className="font-heading text-2xl font-bold text-black dark:text-white">Support</h2>
              <button
                onClick={onClose}
                className="hidden h-8 w-8 items-center justify-center rounded-lg text-black/40 transition hover:bg-black/5 hover:text-black lg:flex dark:text-white/40 dark:hover:bg-white/5 dark:hover:text-white"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <SupportForm onSuccess={onClose} onClose={onClose} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    portalTarget,
  );
}
